export type StallInfo = {
  id: string;
  title: string;
  min_price: number;
  images: Array<{ url: string; sort: number }>;
};

export enum ReportType {
  USER = "user",
  STALL = "stall",
}

export type SubmitReportData = {
  target_id: string;
  type: ReportType;
  content: string;
  evidence: string[];
};

export enum ReportStatus {
  SUBMITTED = 0,
  PROCESSING = 1,
  COMPLETED = 90,
  REJECTED = 91,
  CANCELLED = 92,
}
